/* global debounce */

// // Seleccionamos todas las tarjetas de producto
// const productCards = document.querySelectorAll('product-card');

// productCards.forEach(card => {
//   // Al pasar el ratón sobre la tarjeta
//   card.addEventListener('mouseenter', () => {
//     card.querySelector('upng-product-form').style.visibility = 'visible'; // Mostrar el botón
//     card.style.transform = 'scale(1.05)'; // Elevar la tarjeta
//   });

//   // Al sacar el ratón de la tarjeta
//   card.addEventListener('mouseleave', () => {
//     card.querySelector('upng-product-form').style.visibility = 'hidden'; // Ocultar el botón
//     card.style.transform = 'scale(1.0)'; // Devolver a la posición original
//   });
// });

if (!customElements.get('upng-variant-picker')) {
    class VariantPicker extends HTMLElement {
    constructor() {
        super();
        this.section = this.closest('.js-product');
        this.optionSelectors = this.querySelectorAll('.option-selector');
        this.data = this.getProductData();
        this.variant = this.getSelectedVariant();
        this.productForm = this.querySelector('.js-product-form') || this.section.querySelector('.js-product-form');
      if (this.variant) {
        // Ensure form inputs reflect the initially selected variant
        try { this.updateVariantInput(); } catch (e) {}
        this.updatePrice();
      }
        this.addEventListener('change', this.handleVariantChange.bind(this));
        // Some browsers or custom label clicks may not always fire a bubbling 'change'
        // on radios reliably in the context of custom elements. Add click delegation
        // so clicks on option inputs/labels always trigger variant selection.
        this.addEventListener('click', (evt) => {
          const optInput = (evt.target.closest && evt.target.closest('.js-option'))
            || (evt.target.closest && evt.target.closest('label') && this.querySelector(`#${evt.target.closest('label').htmlFor}`));
          if (optInput) this.handleVariantChange(evt);
        });
    }
    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
        if (evt.target && evt.target.classList.contains('qty-input__input')) {
            return;
        }
        this.variant = null;
        // Get selected variant data (if variant exists).
        this.variant = this.getSelectedVariant();
  
        if (this.variant) {
          this.updateVariantInput();
          // Update price and labels on the page using formatted JSON
          this.updatePrice();
        }
        // debug trace to help detect selection issues
        try {
          console.debug('[upng-variant-picker] variant change ->', this.variant && this.variant.id);
        } catch (e) {}

        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          composed: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }
      getProductData() {
        const dataEl = this.querySelector('[type="application/json"]');
        try {
          return JSON.parse(dataEl.textContent);
        } catch (e) {
          try {
            console.error('[upng-variant-picker] Failed to parse product JSON', e, dataEl && dataEl.textContent && dataEl.textContent.substring(0, 2048));
          } catch (err) {}
          return { product: { variants: [] }, formatted: {} };
        }
      }
      getSelectedOptions() {
        const selectedOptions = [];
  
        this.optionSelectors.forEach((selector) => {
          if (selector.dataset.selectorType === 'dropdown') {
            selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
          } else {
            selectedOptions.push(selector.querySelector('input:checked').value);
          }
        });
  
        return selectedOptions;
      }
      getSelectedVariant() {
        const selectedOptions = this.getSelectedOptions();
        return this.data.product.variants.find(
          (v) => v.options.every((val, index) => val === selectedOptions[index])
        );
      }
      updateVariantInput() {
        this.forms =
          this.forms || this.section.querySelectorAll('.js-product-form');
  
        this.forms.forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          if (!input) return;
          // Ensure input is enabled (some templates render it disabled initially)
          try { input.disabled = false; } catch (e) {}
          input.value = this.variant.id;
          // Dispatch change so any listeners that read the input value pick it up
          try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
        });
      }
      updatePrice() {
        if (!this.variant) return;
        const formatted = this.data.formatted[this.variant.id] || {};
        const priceContainer = this.section.querySelector('.product-info__price > .price');
        if (!priceContainer) return;
        const priceCurrentEl = priceContainer.querySelector('.price__current');
        const priceWasEl = priceContainer.querySelector('.price__was');
        if (priceCurrentEl) priceCurrentEl.innerHTML = formatted.price || '';
        if (priceWasEl) priceWasEl.innerHTML = formatted.compareAtPrice || '';

        // Update sale label
        const saleLabelEl = this.section.querySelector('.product-label--sale');
        let discountPercent = 0;
        const empApplied = formatted.employee_applied || false;
        const empPercent = formatted.employee_discount_percent || 0;
        const jsonDiscount = (formatted.discount_percent !== undefined) ? Number(formatted.discount_percent) : null;
        const priceAmount = Number(formatted.price_amount || this.variant.price || 0);
        const compareAmount = Number(formatted.compare_at_price_amount || this.variant.compare_at_price || 0);
        if (jsonDiscount !== null) {
          discountPercent = Number(jsonDiscount);
        } else if (empApplied && empPercent > 0) {
          discountPercent = Number(empPercent);
        } else if (compareAmount > 0 && priceAmount > 0) {
          discountPercent = Math.round((compareAmount - priceAmount) * 100 / compareAmount);
        }
        if (saleLabelEl) {
          const labelType = (window.theme && window.theme.settings && window.theme.settings.sale_label_type) || 'percent';
            if (labelType === 'percent') {
              if (discountPercent > 0) {
              const template = (window.theme && window.theme.strings && window.theme.strings.percentReduction) || '[amount]%';
              saleLabelEl.innerHTML = template.replace('[amount]', String(discountPercent));
                try {
                  const formattedPrice = Number(this.data.formatted[this.variant.id].price_amount || this.variant.price || 0);
                  const computedDiscountCents = Math.round(compareAmount * discountPercent / 100);
                  const computedFinalCents = compareAmount - computedDiscountCents;
                  if (formattedPrice !== computedFinalCents) {
                    console.debug('[upng-variant-picker] price mismatch:', { formattedPrice, computedFinalCents, compareAmount, discountPercent });
                  }
                } catch (e) {}
            } else {
              saleLabelEl.textContent = '';
            }
          } else {
            // fallback to percent: (money formatting not robust client-side here)
            saleLabelEl.textContent = discountPercent > 0 ? `-${discountPercent}%` : '';
          }
        }
        // Toggle sale class
        if (priceContainer) {
          const priceNum = Number(formatted.price_amount || this.variant.price || 0);
          const compareNum = Number(formatted.compare_at_price_amount || this.variant.compare_at_price || 0);
          priceContainer.classList.toggle('price--on-sale', compareNum > priceNum);
        }
      }
    }
    customElements.define('upng-variant-picker', VariantPicker);
}

if (!customElements.get('upng-product-form')) {
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        if (this.hasChildNodes()) this.init();
      }
  
      init() {
        this.form = this.querySelector('.js-product-form');
        if (this.form) {
          this.form.querySelector('[name="id"]').disabled = false;
          this.cartDrawer = document.querySelector('cart-drawer');
          this.submitBtn = this.querySelector('[name="add"]');
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
  
          if (this.dataset.showQuantitySelector) {
            this.quantitySelector = this.querySelector('quantity-input');
  
            if (this.quantitySelector) {
              this.quantityInput = this.quantitySelector.querySelector('.qty-input__input');
              this.quantitySelector.addEventListener('change', debounce(this.handleChange.bind(this)));
              this.lineItemChangeListener = this.lineItemChangeListener
                || this.handleLineItemChange.bind(this);
              document.addEventListener('on:line-item:change', (evt) => {
                this.lineItemChangeListener(evt);
              });
            }
          }
  
          this.setMaximumInputQuantity();
          this.handleQuantityButtonState();
          document.addEventListener('on:variant:change', this.setMaximumInputQuantity.bind(this));
        }
      }
  
      disconnectedCallback() {
        document.removeEventListener('on:line-item:change', this.lineItemChangeListener);
      }
  
      /**
       * Sets the max attribute of the quantity input
       */
      setMaximumInputQuantity() {
        const productInfo = this.closest('.product-info') || this.closest('quick-add-drawer');
        if (productInfo) {
          const quantitySelector = this.querySelector('quantity-input');
          if (quantitySelector) {
            const quantityInput = quantitySelector.querySelector('.qty-input__input');
            const dataEl = productInfo.querySelector('.js-inventory-data');
            if (dataEl) {
              const variantId = Number(this.form.querySelector('[name="id"]').value);
              const inventoryJson = JSON.parse(dataEl.textContent);
              const inventory = inventoryJson.find((item) => item.id === variantId);
  
              if (inventory.inventory_management.length !== 0 && inventory.inventory_quantity > 0 && inventory.inventory_policy !== 'continue') {
                quantityInput.max = inventory.inventory_quantity;
  
                const currentQuantity = Number(quantityInput.value);
                if (currentQuantity > 1 && currentQuantity > inventory.inventory_quantity) {
                  quantityInput.value = quantityInput.max;
                }
              }
            }
  
            const minusButton = quantitySelector.querySelector('.btn--minus');
            const plusButton = quantitySelector.querySelector('.btn--plus');
            ProductForm.setQuantityButtonState(null, quantityInput, minusButton, plusButton);
          }
        }
      }
  
      /**
       * Sets the max attribute of the quantity input
       */
      handleQuantityButtonState() {
        const productInfo = this.closest('.product-info') || this.closest('quick-add-drawer');
        if (productInfo) {
          const quantitySelector = this.querySelector('quantity-input');
          if (quantitySelector) {
            const quantityInput = quantitySelector.querySelector('.qty-input__input');
            const minusButton = quantitySelector.querySelector('.btn--minus');
            const plusButton = quantitySelector.querySelector('.btn--plus');
  
            plusButton.addEventListener('click', () => {
              ProductForm.setQuantityButtonState('up', quantityInput, minusButton, plusButton);
            });
  
            minusButton.addEventListener('click', () => {
              ProductForm.setQuantityButtonState('down', quantityInput, minusButton, plusButton);
            });
  
            ProductForm.setQuantityButtonState(null, quantityInput, minusButton, plusButton);
          }
        }
      }
  
      static setQuantityButtonState(direction, quantityInput, minusButton, plusButton) {
        const currentQuantity = Number(quantityInput.value);
        const max = Number(quantityInput.max);
        const min = Number(quantityInput.min);
  
        let newQuantity = currentQuantity;
  
        if (direction === 'up') {
          newQuantity = currentQuantity + 1;
        } else if (direction === 'down') {
          newQuantity = currentQuantity - 1;
        }
  
        // Enable or disable buttons based on the newQuantity relative to max and min
        minusButton.disabled = newQuantity <= min;
        plusButton.disabled = max > 0 && newQuantity >= max;
      }
 
      
      async handleSubmit(evt) {
        if (evt.target.id === 'product-signup_form') return;
  
        evt.preventDefault();
  
        if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;
  
        if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
          window.navigator.vibrate(100);
        }
  
        this.errorMsg = null;
        this.setErrorMsgState();
  
        // Disable "Add to Cart" button until submission is complete.
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.classList.add('is-loading');
  
        const formData = new FormData(this.form);
        let sections = 'cart-icon-bubble';
        if (this.cartDrawer) {
          sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }
  
        // Get all quick order lists on the page
        const quickOrderSections = [];
        document.querySelectorAll('quick-order-list').forEach((quickOrderList) => {
          const closestSection = quickOrderList.closest('.shopify-section');
          if (closestSection) {
            const sectionId = closestSection.id.replace('shopify-section-', '');
            // sections.push({
            //   id: `quick-order-list_${sectionId}`,
            //   section: sectionId,
            //   selector: `#quick-order-list_${sectionId}`
            // });
            sections += `,${sectionId}`;
          }
        });
  
        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sections);
  
        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        };
  
        try {
          const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
          if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
          const oldCartData = await oldCartResponse.json();
  
          const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
          const data = await response.json();
          let error = typeof data.description === 'string' ? data.description : data.message;
          if (data.errors && typeof data.errors === 'object') {
            error = Object.entries(data.errors).map((item) => item[1].join(', '));
          }
  
          if (data.status) this.setErrorMsgState(error);
  
          if (!response.ok) throw new Error(response.status);
  
          if (theme.settings.afterAtc === 'page') {
            // Allow the tick animation to complete
            setTimeout(() => {
              window.location.href = theme.routes.cart;
            }, 300);
          } else {
            // Update cart icon count.
            ProductForm.updateCartIcon(data);
  
            // If item was added from Quick Add drawer, show "Added to cart" message.
            const quickAddDrawer = this.closest('quick-add-drawer');
            if (quickAddDrawer) quickAddDrawer.addedToCart();
  
            setTimeout(() => {
              // Update cart drawer contents.
              if (this.cartDrawer) {
                this.cartDrawer.renderContents(
                  data,
                  !quickAddDrawer && ((theme.settings.afterAtc === 'drawer_desktop' && theme.mediaMatches.md)
                    || theme.settings.afterAtc === 'drawer')
                );
  
                // Update the quick order lists on the page
                if (quickOrderSections.length) {
                  quickOrderSections.forEach((quickOrderSection) => {
                    const sectionEl = document.getElementById(quickOrderSection.id);
                    if (!sectionEl) return;
  
                    const el = sectionEl.querySelector(quickOrderSection.selector) || sectionEl;
                    el.innerHTML = ProductForm.getElementHTML(
                      data.sections[quickOrderSection.section],
                      quickOrderSection.selector
                    );
                  });
                }
              } else if (window.location.pathname === theme.routes.cart) {
                const cartItems = document.querySelector('cart-items');
                if (cartItems) {
                  if (cartItems.dataset.empty === 'true') {
                    window.location.reload();
                  } else {
                    cartItems.refreshCartItems();
                  }
                }
              }
            }, 700);
          }
  
          let newQuantity = 1;
  
            // Update the quantity selectors if needed
            if (this.quantitySelector) {
              this.setAttribute('data-show-quantity-selector', 'true');
              this.quantityInput.value = newQuantity;
              this.quantitySelector.currentQty = this.quantityInput.dataset.initialValue;
            }
        } catch (error) {
          console.log(error); // eslint-disable-line
          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: this.errorMsg.textContent
            }
          }));
  
          if (this.cartDrawer) this.cartDrawer.refreshCartDrawer();
        } finally {
          // Re-enable 'Add to Cart' button.
          this.submitBtn.classList.add('is-success');
          this.submitBtn.removeAttribute('aria-disabled');
          setTimeout(() => {
            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.classList.remove('is-success');
          }, 1400);
        }
      }
  
      /**
       * Updates the cart icon count in the header.
       * @param {object} response - Response JSON.
       */
      static updateCartIcon(response) {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble) {
          cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
        }
      }
  
  
      /**
       * Gets the innerHTML of an element.
       * @param {string} html - Section HTML.
       * @param {string} selector - CSS selector for the element to get the innerHTML of.
       * @returns {string}
       */
      static getElementHTML(html, selector) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = html;
  
        const el = tmpl.content.querySelector(selector);
        return el ? el.innerHTML : '';
      }
  
      /**
       * Shows/hides an error message.
       * @param {string} [error=false] - Error to show a message for.
       */
      setErrorMsgState(error = false) {
        this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
        if (!this.errorMsg) return;
  
        this.errorMsg.hidden = !error;
        if (error) {
          this.errorMsg.innerHTML = '';
          const errorArray = Array.isArray(error) ? error : [error];
          errorArray.forEach((err, index) => {
            if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
            this.errorMsg.insertAdjacentText('beforeend', err);
          });
        }
      }
    }
  
    customElements.define('upng-product-form', ProductForm);
  }
  